import React, { useState } from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faTimes } from '@fortawesome/free-solid-svg-icons';
import { Link } from 'react-router-dom';
import Navbar from '../components/Navbar';
import '../styles/Romania.css';
import VideoCarousel from '../components/VideoCarousel';
import { useTranslations } from '../hooks/useTranslations';

const Romania = () => {
    const [showLinks, setShowLinks] = useState(false);
    const [isFormVisible, setFormVisible] = useState(false);
    const { t } = useTranslations();

    const showForm = () => {
      setFormVisible(true);
    };
  
    const hideForm = () => {
      setFormVisible(false);
    };

    return (
        <div className='screen'>
            <div className="romania">
                <Navbar showLinks={showLinks} setShowLinks={setShowLinks} />
                <div className="romania-main">
                <h1>{t('romaniaPage.heading', 'Romania')}</h1>
                <div className='romania-card-container'>
                <div className="romania-card">
                <div className="romania-pic-frame">
                <video
                    autoPlay
                    loop
                    muted
                    playsInline
                    preload="auto"
                    aria-label={t('romaniaPage.video.title', 'Esittelyvideo Romaniasta')}
                >
                    <source src="/romania backround.mp4" type="video/mp4" />
                    <source src="romania backround.mp4" type="video/mp4" />
                    Your browser does not support the video tag.
                </video>
                </div>


                <div className="outside-romania">
                    <div className="lääketiede-romania-text">
                        <h2>{t('romaniaPage.sections.medicine.title', 'Lääketiede Romaniassa')}</h2>
                        <p>{t('romaniaPage.sections.medicine.description', 'Opinnot ovat käytännönläheisiä. Ensimmäiset vuodet keskittyvät teoriaan (prekliininen vaihe), kun taas viimeiset kolme vuotta sisältävät intensiivistä työkokemusta (postkliininen vaihe).')}</p>
                        <Link to="/LääketiedeRomaniassa" aria-label={t('romaniaPage.sections.medicine.linkAria', 'Lue lisää lääketieteen opinnoista Romaniassa')}>
                            {t('common.links.readMore', 'Lue Lisää')}
                        </Link>
                    </div>
                    <div className="tentti-romania-text">
                        <h2>{t('romaniaPage.sections.exams.title', 'Tenttivaatimukset')}</h2>
                        <p>
                          {t('romaniaPage.sections.exams.description', 'Romaniassa huippuyliopistot eivät vaadi kemiaa tai fysiikkaa. Pääsykokeissa keskitytään anatomiaan ja fysiologiaan. Koe on pääpainoitteisesti suullinen.')}
                          <br /><br />
                        </p>
                        <Link to="/Tenttivaatimukset" aria-label={t('romaniaPage.sections.exams.linkAria', 'Lue lisää tenttivaatimuksista')}>
                            {t('common.links.readMore', 'Lue Lisää')}
                        </Link>
                    </div>
                </div>
                </div>
                </div>
                </div>
            </div>

            <div className="vapaa-aika">
                <div className="centered-header">
                    <h1>{t('romaniaPage.leisure.heading', 'Vapaa-aika')}</h1>
                    <p>{t('romaniaPage.leisure.intro', 'Opintojen ohella sinulla on aikaa tutustua Romanian kuuluisiin nähtävyyksiin ja kauniiseen luontoon')}</p>
                </div>
                <div className="vapaa-aika-content">
                <div className="vapaa-aika-text">
                    <h2>{t('romaniaPage.leisure.sectionTitle', 'Vapaa-aika Romaniassa')}</h2>
                    <p>{t('romaniaPage.leisure.sectionDescription', 'Romaniassa on monipuoliset harrastusmahdollisuudet, joista jokainen varmasti löytää itselleen sen oikean harrastuksen. Olit sitten kiinnostunut elokuvista, teatterista, ravintoloista, ratsastuksesta, vaelluksesta tai nyrkkeilystä, Romaniassa harrastukset ovat todella edullisia ja Kelan myöntämästä opintotuesta pystyt kattamaan harrastuksesi.')}</p>
                </div>
                <img src="vapaa-aika.png" alt={t('romaniaPage.leisure.imageAlt', 'Opiskelijoita viettämässä vapaa-aikaa Romaniassa')} className="vapaa-aika-image" loading="lazy" />
                </div>

                <div className="loma-content">
                <img src="Holiday.jpeg" alt={t('romaniaPage.holidays.imageAlt', 'Vuoristomaisema Romaniassa')} className="loma-image" loading="lazy" />
                <div className="loma-text">
                    <h2>{t('romaniaPage.holidays.title', 'Lomat')}</h2>
                    <p>{t('romaniaPage.holidays.christmas', 'Joululoma kestää 2 viikkoa.')}</p>
                    <p>{t('romaniaPage.holidays.winter', 'Hiihtoloma kestää 1 viikon.')}</p>
                    <p>{t('romaniaPage.holidays.easter', 'Pääsiäisloma kestää 11 päivää.')}</p>
                    <p>{t('romaniaPage.holidays.summer', 'Kesäloma kestää 3 kuukautta.')}</p>
                </div>
              </div>

              <VideoCarousel />

              <div className="harrastus-content">
                <div className="harrastus-text">
                    <h2>{t('romaniaPage.hobbies.title', 'Harrastaminen & kustannusarviot')}</h2>
                    <p>{t('romaniaPage.hobbies.summary', 'Lisätietoa harrastuksista sekä niiden kustannuksista.')}</p>
                    <button className="show-form-button" onClick={showForm}>
                      {t('romaniaPage.hobbies.cta', 'Lue lisää')}
                    </button>
                </div>
                {isFormVisible && (
                    <>
                        <div className="overlay" onClick={hideForm}></div>
                        <div className="form-container">
                            <div className='myForm'>
                            <button type="button" className="x-button" onClick={hideForm} aria-label={t('romaniaPage.hobbies.modal.close', 'Sulje lisätietolomake')}>
                              <FontAwesomeIcon
                                icon={faTimes}
                                aria-hidden="true"
                              />
                            </button>
                            <h1>{t('romaniaPage.hobbies.modal.title', 'Harrastaminen & kustannusarviot')}</h1>
                            <div className="content-wrapper">
                                <p dangerouslySetInnerHTML={{ __html: t('romaniaPage.hobbies.modal.main', `Alle 27-vuotiaalle opiskelijalle matkakortti maksaa 7 €/kk. Opiskelijakortilla pääset matkustamaan maan sisällä ilmaiseksi junalla. Romaniasta pääset myös muihin Euroopan maihin tosi edullisesti ja kätevästi. Muun muassa Lontooseen pääsee ajoittain alle 20 punnalla ja Espanjaan 10 €. Koti-ikävän tullessa Bukarestista lentää Suomeen suoralla lennolla kahdessa tunnissa.<br /> <br />
                                    Romanian sisällä sekä naapurimaissa on paljon hienoja matkailukohteita, joihin pääset helposti junalla tai paikallisella bussilla. Kauniita aurinkokohteita ovat Constanța ranta sekä upeat maisemat. Pääkaupungissa Bukarestissa viihtyy kovempikin bailaaja, Cluj-Napocassa on hienoimpia taidepiirteitä, Sighișoarassa on Euroopan parhaiten säilynyt keskiaikainen keskusta, ja kaupungin kadut täyttyvät markkinahumusta joka viikonloppu.<br /> <br />
                                    Romanian ilmasto on aivan mahtava! Niin kuin varmasti tiedät, meillä Suomessa on 2-3 viikkoa vuodessa hyvät helteet, mutta täällä Romaniassa se menee toisin päin. Romaniassa hellettä riittää ympäri vuoden. Romanian yliopistossa saat hyvät lomat, mikäli hoidat työsi hyvin. Koulun lomien pituuksiin pystyt vaikuttamaan itse; mikäli hoidat kaikki kurssisi hyvin etkä joudu uusimaan mitään, voit päästä lomalle jo muutamaa viikkoa aikaisemmin.`) }} />
                            <div className="additional-content">
                                <p dangerouslySetInnerHTML={{ __html: t('romaniaPage.hobbies.modal.additional', `Romaniassa harrastukset maksavat suunnilleen:<br />• Kuntosalijäsenyys, 10€/kk<br />• Elokuvat 4€ <br />• Nyrkkeilykurssi 15-20€/kk <br />• Vapaaottelu kurssi 15-20€/kk<br /> • Ravintolat: laadusta riippuen 3-15€<br /> • Kahvilat: 2-5€ <br />• Jalkapallo, koripallo, lentopallo, sulkapallo noin 15€/kk<br />
                                <br />Ilmaista harrastettavaa löytyy muun muassa:<br /> • Jalkapallo, koripallo, tennis mm. ulkotiloissa<br /> • Kirjastot <br />• Vaeltelu Romanian luonnon ympäristössä/vuoristoissa<br /> • Opastetut turistikiertueet kaupungeissa<br /> • Koulun ohjelmat, joissa esimerkiksi jokainen halutessaan pukeutuu kulttuuri vaatetukseen, kulttuuri ruokapäivät tai koulun tanssiaiset.`) }} />
                            </div>
                            </div>
                            </div> 
                        </div>
                    </>
                )}
                </div>
                <br /> <br />
            </div>
        </div>
    );
};

export default Romania;
